import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson28: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson27"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Weight Training Exercises
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson29"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            To begin this chapter, it's important to emphasize that losing fat
            can be achieved through diet alone, but building muscle without
            weight training is extremely challenging. This realization has led
            experts in the field to conclude that nutrition plays a supportive
            role in muscle building, as it permits the effects of weight
            training. In other words, even with an optimal diet and perfect
            protein intake, significant muscle growth cannot occur without the
            stimulus provided by training.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Therefore, we consider weight training to be the driving force
            behind body recomposition. To illustrate this point, let's use a car
            analogy. Training can be seen as the engine, while nutrition serves
            as the fuel needed to power performance. The quality of the fuel
            (macronutrients, micronutrients, nutrient timing, etc.) directly
            impacts performance. However, without the engine (training), the car
            (body) won't move, regardless of the fuel's quality.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Additionally, factors like sleep and stress management can be seen
            as the necessary maintenance, such as tune-ups, oil changes, and
            tire rotations, to keep the system running smoothly.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Undoubtedly, weight training is of paramount importance in building
            muscle and improving body composition (References 1,2,3 ). However,
            just like nutrition, there are countless variables that need to be
            considered when structuring a training program. These variables
            include factors such as individual goals, experience level, exercise
            preferences, preferred training style, scheduling constraints,
            equipment availability, previous injuries, and many more.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Once these individual components have been identified, specific
            training recommendations can be outlined, focusing on key variables
            such as volume, exercise selection, frequency, and training splits
            when designing a program.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Since this course primarily focuses on nutrition and only dedicates
            one chapter to training, fully covering all these factors would
            require a separate course. Nonetheless, because proper training is
            essential for successful body recomposition, we aim to provide you
            with valuable insights, scientific knowledge, and clarity regarding
            the key training variables responsible for driving muscle growth.
            Let's delve deeper into the topic!
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Proggressive Overload :</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Progressive overload refers to the gradual increase in the
                stress placed on the body during exercise (Reference 4). In
                simple terms, if the muscle isn't subjected to greater stress
                over time, it won't have a reason to grow and adapt.
                Essentially, progressive overload means doing more as time goes
                on. Typically, this involves adding more weight to an exercise
                in each subsequent workout. However, there are various ways to
                apply progressive overload:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Increase the load (weight)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Increase the number of repetitions with the same load
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Increase the number of sets</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Improve exercise form and technique</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Increase the duration of each repetition, such as by slowing
                  down the eccentric/negative phase
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These techniques can be used in combination, and there are other
                creative methods to achieve overload as well. For beginners,
                progress should be made in each workout. However, as individuals
                become more experienced, progress may slow down gradually.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As you advance, it becomes important to apply progressive
                overload over a longer time frame and focus on less quantifiable
                aspects, such as improving technique, lifting tempo, and the
                mind-muscle connection for specific exercises.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When it comes to progression, it is essential to prioritize
                quality over quantity. The concept of progressive overload,
                specifically progressive tension overload, is effective because
                it increases mechanical tension, which is a key factor in muscle
                hypertrophy (References 5, 6).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is crucial to maintain consistent form and execution when
                adding load to the bar for progressive tension overload. Adding
                weight at the expense of compromising proper technique is not
                advisable. While occasional controlled cheating techniques can
                be employed in advanced training, adding weight through
                excessive momentum, reducing the range of motion, or altering
                lifting mechanics does not qualify as true progressive overload.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Volume = Growth</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Training volume, which refers to the amount of work performed
                  during training, plays a crucial role in muscle hypertrophy.
                  While there is a suggested dose-response relationship between
                  volume and muscle growth, recent evidence shows that more
                  volume is not always better, and the optimal volume needed for
                  maximizing growth depends on other training variables.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It is important to note that not all volume is equal, and the
                  required volume for maximizing growth may vary depending on
                  the specific body part being trained. Generally, most trainees
                  should aim for a range of 10-20 sets per body part per week,
                  based on coaching experience and scientific research. However,
                  advanced trainees or those with exceptional recovery abilities
                  may require higher volumes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A recent study conducted by the author and colleagues explored
                  the effects of different training volumes on the lower body.
                  Interestingly, the hypertrophy results were similar among
                  groups using 12, 18, and 24 sets per week. However, the
                  individual responses varied greatly, indicating the need for
                  tailoring the volume to specific goals and individual
                  variables.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In summary, while training volume is an important factor for
                  muscle growth, the optimal volume needed is highly
                  individualized. It is crucial to consider various factors and
                  adapt the volume accordingly to achieve the best results.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">
                  Your current training status and previous training experience
                  will play a large role in determining how much volume you
                  should perform.
                </i>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">{`Generally, beginners should train with lower volumes than advanced trainees. `}</i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">{`We recommend starting with relatively low volumes at the beginning of a program and gradually increasing volume over time. `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Volume can be increased by adding working sets and/or by
                    lifting more load (weight) and/or adding more reps per set.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    More isn’t always better! Adding too much volume can result
                    in overtraining or injury and can be counterproductive to
                    body recomposition.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Increasing volume isn’t the only way to drive progress. We
                    think it is better to underestimate your optimal volume
                    initially and focus first on mastering variables like
                    technique and effort before turning to increasing volume.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>{` `}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Below are some figures to help explain that there is always a
                  sweet spot for volume that will need to be fine-tuned to the
                  individual.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[70.25rem] h-[49.06rem] object-cover"
          alt=""
          src="/60@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Key Terms:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <i>
                MV = Maintenance volume. Volume required to maintain your
                current physique. (No loss, no gains)
              </i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>&nbsp;</i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>
                MED = Minimum effective dose. This is the least volume you need
                to see some growth, but not maximize growth.
              </i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>&nbsp;</i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>
                MAV = Maximum adaptive volume. This is the proverbial sweet spot
                for volume: You are able to maximize progress without
                accumulating excessive fatigue.
              </i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>&nbsp;</i>
            </span>
          </p>
          <p className="m-0">
            <span>
              <i>
                MRV = Maximum recoverable volume. This is the most volume you
                can do and still recover from. Increasing volume further would
                likely lead to a detriment in performance and/or muscle size.
              </i>
            </span>
          </p>
        </div>
        <img
          className="relative w-[70.25rem] h-[38.13rem] object-cover"
          alt=""
          src="/61@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            It is important to recognize that not all volume is equal in terms
            of its impact on muscle growth. Certain exercises require a higher
            level of skill and effort compared to others. For instance,
            performing a set of bench press is generally more effective for
            hypertrophy than a set of pec deck. Similarly, completing four sets
            of squats will create greater local and systemic fatigue compared to
            four sets of leg press.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Moreover, different exercises can result in varied patterns of
            hypertrophy within a specific muscle group, even when the volume is
            matched. A study conducted in 2014 demonstrated that despite
            matching total volume, a group performing four different exercises
            (squats, leg press, lunges, and deadlifts) experienced significant
            hypertrophy in all four heads of the quadriceps. On the other hand,
            the group performing only one exercise (squats) showed significantly
            less gains in two heads of the quad, including the "tear-drop" head.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This research suggests that considering not only volume but also
            incorporating a variety of exercises is crucial for maximizing
            growth potential. By diversifying the exercises, you can target
            different areas of a muscle group and promote balanced development.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Not All Exercises Are Created Equal</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is evident from the aforementioned research that not all
                exercises are equally effective for muscle development.
                Including a variety of exercises in your training program is
                crucial for optimizing the complete development of a muscle
                group.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In general, it is recommended to prioritize multi-joint,
                compound movements that engage large muscle groups. These
                exercises not only enhance overall strength but also save time
                since they activate multiple muscles simultaneously. Here are
                some fundamental compound exercises that we suggest
                incorporating into your program:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Legs: Squat variation, lunge, leg press, deadlift variation,
                  hip thrust
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Back/biceps: Horizontal pull (row variation), vertical pull
                  (pullup/pulldown)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Chest/triceps: Horizontal press (dumbbell, barbell, machine)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Shoulders: Vertical press (barbell, dumbbell)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While compound exercises should form the foundation of your
                training, certain muscles can be better targeted through
                single-joint isolation exercises. Here are some basic isolation
                exercises that we recommend including in your program,
                particularly if you feel these muscles are lagging in your
                physique:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Rear deltoids: Reverse pec deck, reverse flyes (cable or
                  dumbbell)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Side deltoids: Lateral raise (cable, dumbbell, machine)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Biceps: Curl variation (dumbbell, barbell, cable)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Triceps: Cable pressdown, overhead extension, skullcrusher
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Hamstrings: Leg curl variation (lying, seated, GHR)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Calves: Calf raise (standing, seated)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Abs/obliques: Crunch (cable, weighted), leg raise, planks,
                  anti-rotation
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While these exercises should be prioritized in your training,
                you can certainly include other exercises not listed here based
                on your specific needs, goals, and preferences. Customizing your
                program to suit your individual requirements will help you
                achieve the best results.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Training Hard</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The variation in training volumes also extends to the intensity
                of the sets. The question arises: should we consistently train
                sets to failure or stop short of failure?
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although the scientific literature currently lacks a clear
                consensus on the optimal frequency of training sets to failure
                for maximizing muscle growth, it is evident that putting in a
                high level of effort is crucial for progressing beyond the
                beginner stage. However, this does not mean that every set
                should be taken to failure. Taking sets to complete fatigue on a
                consistent basis can lead to overtraining, reduced overall
                volume, and potentially hinder growth.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As a general guideline, we recommend leaving one to three reps
                "in the tank" for most compound exercises. This means stopping
                the set when you could have performed one to three more
                repetitions with proper form. Isolation exercises can be taken
                closer to failure more frequently without the same risk of
                accumulating excessive fatigue. However, we still advise
                reserving failure for the last set of any given exercise.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By strategically managing the intensity of your sets and
                avoiding excessive fatigue, you can strike a balance between
                challenging your muscles and allowing for adequate recovery,
                promoting continuous progress in your training.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>What Is The Best Rep Range For Muscle Growth?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When it comes to achieving muscle hypertrophy, research suggests
                that similar levels of growth can be attained with both low reps
                (heavy weight) and high reps (light weight), as long as
                appropriate effort and volume are applied. Therefore, the
                specific rep range you work in may have less significance for
                hypertrophy than commonly believed, assuming you are training
                with sufficient intensity.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, we still advocate for a "practical hypertrophy zone" in
                which the majority of your working sets should fall. This zone
                is typically defined as 6-15 reps. There are two primary reasons
                why we consider this rep range preferable for building muscle.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Firstly, as the rep count surpasses 15, the accumulation of
                metabolic fatigue becomes more pronounced, which can be mentally
                and physically taxing. Consequently, since similar hypertrophy
                can be achieved with lower reps, we generally recommend
                reserving higher rep work (15-25+ reps) for isolation exercises
                performed towards the end of the workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Conversely, sets with fewer than six reps carry a higher risk of
                injury due to the heavier loads involved and may make it
                challenging to accumulate an appropriate volume of training.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While there is no inherent magic in the 6-15 rep range, it
                proves to be the most practical approach in practice. It allows
                you to perform sufficient work safely and comfortably without
                encountering the recovery issues commonly associated with the
                extremes of the rep range.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This does not imply that there is no room for "pure strength
                work" (sets with less than six reps) or "pure pump work" (sets
                with more than 15 reps). We recommend allocating approximately
                75 percent of your weekly training volume to the 6-15 rep zone,
                providing a balanced approach to maximize hypertrophy.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Training Frequency And Training Splits</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Should you train each body part once a week? Twice a week?
                  Every day?
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It seems that as a whole, the scientific literature suggests
                  that training each muscle twice per week is better than only
                  training each muscle once per week. Whether or not frequencies
                  higher than that are better, seems to depend on the
                  individual.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  This finding has a few implications for training splits. For
                  example, the traditional bodybuilding bro split where chest is
                  hit on Monday, back is hit on Tuesday, et cetera, is not
                  likely to maximize progress due to suboptimal training
                  frequency.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  There are a virtually infinite number of ways that you can
                  split up your training during the week to meet the two times
                  frequency minimum. Below are a few examples of splits we have
                  had success with:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>THE UPPER LOWER SPLIT (BEGINNER-INTERMEDIATE)</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem] text-gainsboro-100">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 1 - Upper</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 2 – Rest</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 3 – Lower</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 4 – Rest</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 5 – Upper</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 6 – Rest</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Day 7 – Lower</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>THE UPPER LOWER SPLIT (INTERMEDIATE-ADVANCED)</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem] text-gainsboro-100">
            <li className="mb-[0rem]">
              <span>
                <span>Day 1 - Upper</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 2 – Lower `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 3 – Upper `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 4 – Lower `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 5 – Upper `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 6 – Lower `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Day 7 – Rest</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>{`THE PUSH PULL LEGS SPLIT (INTERMEDIATE-ADVANCED) `}</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem] text-gainsboro-100">
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 1 – Push `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 2 – Pull `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 3 – Legs `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 4 – Push `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 5 – Pull `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 6 – Legs `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Day 7 – Rest</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>THE FULL BODY SPLIT (BEGINNER-INTERMEDIATE)</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem] text-gainsboro-100">
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 1 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 2 – Rest `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 3 – Rest `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 4 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 5 – Rest `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 6 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Day 7 – Rest</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>{`THE FULL BODY SPLIT (ADVANCED-ELITE) `}</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem] text-gainsboro-100">
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 1 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 2 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 3 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 4 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 5 – Full Body `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Day 6 – Rest `}</span>
              </span>
            </li>
            <li>
              <span>
                <span>Day 7 – Rest</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>The exercises to do:</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Push Day :</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>15° Incline Dumbbell Press 12-10-8</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Set Up:</b>
                <span>
                  {" "}
                  Adjust your bench to a 15° incline. A slight incline targets
                  the upper pectorals without putting too much stress on the
                  anterior deltoids.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Starting Position:</b>
                <span>
                  {" "}
                  Sit on the bench with a dumbbell in each hand, resting on your
                  thighs. Use your thighs to help push the dumbbells up as you
                  lean back. Position the dumbbells at chest height, elbows bent
                  and angled slightly below your shoulders, palms facing
                  forward.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Grip:</b>
                <span>
                  {" "}
                  Grip the dumbbells firmly but without over-squeezing, which
                  could unnecessarily raise your blood pressure and cause
                  excessive forearm fatigue.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Foot Placement:</b>
                <span>
                  {" "}
                  Plant your feet firmly on the ground, hip-width apart. This
                  stable base will help you control the weight and maintain good
                  form.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Lift Off: `}</b>
                <span>
                  Push the dumbbells up and slightly toward each other, but
                  don't let them touch. This motion should be smooth and
                  controlled. Exhale as you push up.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Top Position:</b>
                <span>
                  {" "}
                  Once your arms are fully extended (without locking out your
                  elbows), pause for a moment. You should feel your chest
                  muscles contract.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Lowering the Weight: `}</b>
                <span>
                  Inhale as you slowly lower the dumbbells back to the starting
                  position. Your arms should come down in a wide arc until the
                  dumbbells are level with your chest and your upper arms are
                  slightly below parallel to the ground.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Pacing:</b>
                <span>
                  {" "}
                  Aim for a count of two seconds to press up and three seconds
                  to return to the starting position. This controlled tempo
                  reduces momentum, making your muscles work harder.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Repetition:</b>
                <span>
                  {" "}
                  Perform the desired number of repetitions without compromising
                  form. It's better to do fewer reps correctly than more reps
                  with poor form.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`End of Set: `}</b>
                <span>
                  When you've completed your set, don’t drop the dumbbells to
                  the side. Instead, bring them down to your chest first and
                  then use your thighs to assist in returning them to the ground
                  safely.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Safety:</b>
                <span>
                  {" "}
                  If you are lifting heavy or to failure, have a spotter nearby
                  to assist you.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <b className="font-dm-sans">Consistency:</b>
                <span>
                  {" "}
                  Like any exercise, consistency and progression are key. Over
                  time, gradually increase the weight to continue challenging
                  your muscles.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[70.25rem] h-[53.38rem] object-cover"
          alt=""
          src="/62@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">Decline Dumbbell Press 12-10-8</p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b>{`Lie Down Safely: `}</b>
              <span>
                Sit at the top of the decline bench with a dumbbell in each hand
                resting on your thighs. As you lie back, bring the dumbbells to
                the sides of your chest. Secure your legs at the end of the
                bench if it has leg hooks.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">{`Grip and Wrist Position: `}</b>
              <span>
                Hold the dumbbells with a neutral grip (palms facing each other)
                or a pronated grip (palms facing away from you), and keep your
                wrists straight to prevent strain.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">Pressing Motion:</b>
              <span>
                {" "}
                Push the dumbbells up and slightly towards each other in a
                smooth, controlled motion while exhaling. The dumbbells should
                follow a slight inward arc, not a straight line. Avoid clanging
                the weights together at the top, as this can reduce muscle
                tension.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">{`Upper Body Position: `}</b>
              <span>
                Keep your chest up and shoulder blades retracted throughout the
                movement. Do not allow your back to arch excessively.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">Lowering the Dumbbells:</b>
              <span>
                {" "}
                Inhale as you slowly lower the dumbbells back to the starting
                position. The dumbbells should come down to the sides of your
                chest, not your shoulders, to keep tension on your pecs and
                reduce the risk of shoulder injury.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li>
              <b className="font-dm-sans">Range of Motion:</b>
              <span>
                {" "}
                Lower the dumbbells until your upper arms are slightly below
                parallel to the floor, then press them back up to full extension
                without locking out your elbows.
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[70.25rem] h-[39.5rem] object-cover"
          alt=""
          src="/63@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Seated Dumbbell Shoulder Press 12-10-8
          </div>
          <img
            className="relative w-[45.31rem] h-[26.44rem] object-cover"
            alt=""
            src="/64@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Cable lateral raises 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[26.88rem] object-cover"
            alt=""
            src="/65@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            V bar triceps pushdown 12-10-8 “ Last set do dropset until Failure”
          </div>
          <img
            className="relative w-[45.13rem] h-[26.88rem] object-cover"
            alt=""
            src="/i32@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Dips until failure 3x
          </div>
          <img
            className="relative w-[45.13rem] h-[43.19rem] object-cover"
            alt=""
            src="/66@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Pull Day :</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>Lat pulldowns 12-10-10-8</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/67@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Cable row (elbows angled out) 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/68@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Back cable pulldown 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/69@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Cable Rear Delt flyes 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/70@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Shoulder shrugs exercise 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/71@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Chin Ups 3x Until failure
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/72@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Dumbbell Incline Hammer Curl 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/73@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Legs Day “Hamstrings + Glutes” focused :</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <b>
                <span>&nbsp;</span>
              </b>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>Legs Day “Hamstrings + Glutes” focused :</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/74@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Hip Thrusts : 12-12-12
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/75@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Nordic Leg curls : 3x ( You put 3 min Timer you do 5 reps on every
            start of a minute you go down slowly )
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/76@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Hamstring Cruls Seated : 4*12
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/77@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Machine 45 Degree Back Extension : 3*10
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/78@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Seated Calf Raises seated 15-15-15
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/79@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Upper Day : High intensity / heavy weight</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <b>
                <span>&nbsp;</span>
              </b>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>Lat Pulldown 3*8</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/67@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            cable chest fly 3*6-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/81@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Shoulder press 3*6-8
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/82@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            wide grip cable row 3*10-12
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/68@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            15° Incline Dumbbell Press 3*8
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/84@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Lat Raises 10*3
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/85@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Overhead Tricep Extension 3*8
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/86@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Dumbbell Incline Hammer Curl 3*8
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/87@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Lower Day :</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Hack Squats 12-12-12- Last One drop set try to do atleast 25
                  reps
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[25.94rem] object-cover"
            alt=""
            src="/88@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Bulgarian Split Squats 12-10-8
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/89@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Leg Extension : 20 20 20 20 “Moderate weight” focus on high reps
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/90@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Hip abduction 15*3
          </div>
          <img
            className="relative w-[45.13rem] h-[29.56rem] object-cover"
            alt=""
            src="/91@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            Calf raises 15*3 light weight slow motion
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/92@2x.png"
          />
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson29"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson28;
